import { GlobalLoading } from "~/design-system/components/loaders/GlobalLoading";
import { Toaster } from "~/design-system/components/ui/sonner";
import { CookieConsentBanner } from "~/modules/cookies/components";
import {
  Footer,
  GoogleReviewsButton,
  PortalsWrapper,
  ToTopButton,
} from "~/modules/shared/components";
import { CartDrawer } from "../../components/Header/components";
import { HeaderV2 } from "../../components/HeaderV2";
import { ContactUsButton } from "~/modules/shared/components/ContactUsButton";

type CommonLayoutProps = {
  children: React.ReactNode;
};

export function CommonLayout({ children }: CommonLayoutProps) {
  return (
    <div className="relative">
      <CartDrawer />
      <HeaderV2 />
      <PortalsWrapper />
      <Toaster />
      <GlobalLoading>{children}</GlobalLoading>
      <Footer />
      <CookieConsentBanner />
      <ToTopButton />
      <GoogleReviewsButton />
      <ContactUsButton />
    </div>
  );
}
